import { Link } from 'react-router-dom';
import facebookIcon from '@assets/icons/icon-facebook.svg';
import instagramIcon from '@assets/icons/icon-instagram.svg';
import hashtag from '@assets/images/zaslouzisivic.svg';
import socialMediaDog from '@assets/images/social-media-dog.webp';



const SocialMedia = (): JSX.Element => {

	return (
		<div className='component-social-media'>

			<h2>Jsme i na sociálních sítích!</h2>

			<p>Rádi se podělíme o Vaše příběhy a&nbsp;zkušenosti s VETlímci.</p>

			<div className='social-media-icons'>
				<Link to={'https://www.facebook.com/vetlimce'} className='disable-selection'>
					<img src={facebookIcon} alt='social-media-facebook' />
				</Link>

				<Link to={'https://www.instagram.com/vetlimce'} className='disable-selection'>
					<img src={instagramIcon} alt='social-media-instagram' />
				</Link>
			</div>

			<div className='social-media-photo'>
				<img src={socialMediaDog} alt='social-media-photo' />	
			</div>

			<div className='social-media-hashtag'>
				<img src={hashtag} alt='social-media-hashtag' />	
			</div>

		</div>
	);
};

export default SocialMedia;